// extracted by mini-css-extract-plugin
export default {"info-bar":"InfoBar_info-bar__V0Rwa","info-bar-body":"InfoBar_info-bar-body__cNHmz","info-bar-extra":"InfoBar_info-bar-extra__UmAJw"};